import antdEn from "antd/lib/locale/en_GB";
import appLocaleData from "react-intl/locale-data/en";
import enMessages from "../locales/en.json";
// Keys not in POEditor yet. The deploy overwrites en.json from POEditor, so
// new keys live here until they are added there; POEditor values win.
import pendingEn from "../locales/pending/en.json";

const EnLang = {
  messages: {
    ...pendingEn,
    ...enMessages
  },
  antd: antdEn,
  locale: 'en-gb',
  data: appLocaleData
};
export default EnLang;
